export default __webpack_public_path__ + "static/media/考生信息批量导入模版.708a8192.xlsx";